module.exports = "img/flags/AG.8ffe9c5.png";